import React from "react"

import SelectTags from "../tags/SelectTags"

import ConceptMappingItem from "./ConceptMappingItem"
import ConceptMappingPreview from "./ConceptMappingPreview"

const ConceptMappingsEditWidget = ({
    onRemoveMapping,
    onConceptSearch,
    mappingToBeAdded,
    mappingToBeDeleted,
    onAddMapping,
    onUpdateConcepts,
    onClearConcepts,
    isFetchingPreview,
    beforeCount,
    afterCount,
    mappings,
    after,
}) => {
    mappings = mappings.map((mapping) => ({
        ...mapping,
        fakeId:
            mapping.id ||
            mapping.positive.map(({ id }) => `pos-${id}`).join("-"),
    }))
    return (
        <div className="widget">
            <h3 className="widget-header">
                <span className="icon icon-concepts" />
                Mappings
            </h3>
            <hr />
            <div className="widget-content overflow">
                <div className="mapping-box clearfix">
                    {mappings.map((mapping) => (
                        <ConceptMappingItem
                            key={mapping.id || mapping.fakeId}
                            {...mapping}
                            onRemoveMapping={onRemoveMapping}
                        />
                    ))}
                    {mappings.length === 0 && "No mappings"}
                </div>
                <div className="mapping-build clearfix">
                    <h5>Add concepts</h5>
                    <SelectTags
                        name="concepts-positive"
                        value={mappingToBeAdded.positive}
                        loadOptions={onConceptSearch}
                        filterOption={() => true}
                        onChange={onUpdateConcepts(true)}
                    />
                    <div className="map-buttons">
                        <button
                            className="btn btn-cancel"
                            onClick={onClearConcepts}
                            disabled={
                                !mappingToBeDeleted &&
                                mappingToBeAdded.positive.length <= 0
                            }
                        >
                            Clear
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={onAddMapping}
                            disabled={mappingToBeAdded.positive.length <= 0}
                        >
                            Add
                        </button>
                    </div>
                </div>
                {(mappingToBeDeleted ||
                    mappingToBeAdded.positive.length > 0) && (
                    <ConceptMappingPreview
                        previewMapping={mappingToBeDeleted || mappingToBeAdded}
                        isDeleting={mappingToBeDeleted !== null}
                        isFetching={isFetchingPreview}
                        afterCount={afterCount || 0}
                        beforeCount={beforeCount || 0}
                        after={after}
                    />
                )}
            </div>
        </div>
    )
}

export default ConceptMappingsEditWidget
